import React from "react";
import { Chip, Grid } from "@material-ui/core";
import { CtrlGoodsFilter } from "../../../data/clearing/ctrlgoods/types";
import { LocalizationContext } from "../../../core/localization/Localization";

export const CtrlGoodsFilterChipsComponent: React.FunctionComponent<CtrlGoodsFilterChipsProps> = ({
  filter,
  removeFilter,
}) => {
  const { getDateString, getString } = React.useContext(LocalizationContext);
  return (
    <Grid container spacing={1}>
      {filter.datefrom && (
        <Grid item>
          <Chip
            label={`${getString("filterFrom")}: ${getDateString(
              new Date(filter.datefrom)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("datefrom")}
          />
        </Grid>
      )}
      {filter.dateto && (
        <Grid item>
          <Chip
            label={`${getString("filterTo")}: ${getDateString(
              new Date(filter.dateto)
            )}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("dateto")}
          />
        </Grid>
      )}
      {filter.product && (
        <Grid item>
          <Chip
            label={`${getString("ctrlproductName")}: ${filter.product.prodName}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("product")}
          />
        </Grid>
      )}
      {filter.client && (
        <Grid item>
          <Chip
            label={`${getString("paymentClientName")}: ${filter.client.cliName}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("client")}
          />
        </Grid>
      )}

      {filter.buyer && (
        <Grid item>
          <Chip
            label={`${getString("ctrlbuyerName")}: ${filter.buyer.cliName}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("buyer")}
          />
        </Grid>
      )}
      {filter.seller && (
        <Grid item>
          <Chip
            label={`${getString("ctrlsellerName")}: ${filter.seller.cliName}`}
            color="secondary"
            variant="outlined"
            onDelete={() => removeFilter("seller")}
          />
        </Grid>
      )}

    </Grid>
  );
};

interface CtrlGoodsFilterChipsProps {
  filter: CtrlGoodsFilter;
  removeFilter: (type: keyof CtrlGoodsFilter) => void;
}
